// src/api/http.js
const API_BASE = process.env.REACT_APP_API_BASE || "";

export function apiUrl(path) {
  return `${API_BASE}${path}`;
}

export async function apiGetJson(path, opts = {}) {
  const r = await fetch(apiUrl(path), {
    method: "GET",
    cache: "no-store",                 // evita 304
    headers: {
      "Accept": "application/json",
      "Cache-Control": "no-cache",
      ...(opts.headers || {}),
    },
  });

  if (!r.ok) {
    const txt = await r.text().catch(() => "");
    throw new Error(`HTTP ${r.status} ${r.statusText} on GET ${path} :: ${txt}`);
  }

  return r.json();
}
